module.exports = __webpack_public_path__ + "img/lang-34.177ebe1b.jpg";